import React, { useContext, useEffect } from "react";
import { FilterContext } from "context/FilterContext";
import { Divider } from "styled_components/Common/Divider";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { string } from "prop-types";
import styled from "styled-components";
import { DownArrowSVG } from "styled_components/SVG/DownArrowSVG";

const handleColorType = (module, theme) => {
  switch (module.toLowerCase()) {
    case "storage":
      return theme.storage;
    case "account":
      return theme.account;
    case "billing":
      return theme.billing;
    case "support":
      return theme.support;
    case "colocation":
      return theme.colocation;
    default:
      return theme.main;
  }
};

const FilterStyle = styled.div`
  position: absolute;
  z-index: 1000;
  :hover {
    z-index: 1000;
  }
  width: 152px;
  height: 40px;
  .divider {
    margin-top: 0px !important;
  }
  &.xs {
    width: 50px;
    .filter-title {
      background-color: rgba(212, 215, 216, 0.4);
      border-radius: 4px;
      border: 1px solid #cfd2d3;
      .title {
        padding-left: 5px;
      }
    }
    .filter-selected {
      height: 30px;
    }
    .filter-selected:hover {
      .filter-reveal {
        height: 100px;
        &.five {
          height: 120px;
        }
        &.long {
          height: 130px;
        }
      }
    }
    .filter-reveal {
      width: 50px;
      margin-top: 30px;
      .divider {
        display: none;
      }
      .filter-dd-wrapper {
        height: 100px;

        &.five {
          height: 120px;
        }
        &.long {
          height: 130px;
        }
        .filter-selections {
          padding-right: 0px;
          padding: 0px;
          padding-left: 5px;
        }
      }
    }
  }
  .filter-reveal {
    //transform: translate(-50%, 0%);
    position: absolute;
    //left: 50%;
    top: 0%;
    width: 152px;
    height: 0px;
    overflow: hidden;
    transition: width 2.5s, height 1s ease-in-out;
    margin-top: 40px;
    background: ${(props) => props.theme.white};

    .filter-dd-wrapper {
      width: 100%;
      height: 120px;
      background: ${(props) => props.theme.white};
      &.five {
        height: 185px;
      }
      &.long {
        height: 168px;
      }

      .selected {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        text-transform: capitalize;
        color: ${(props) => handleColorType(props.module, props.theme)};
      }
      .filter-selections {
        position: relative;
        text-transform: capitalize;
        padding: 24px;
        padding-right: 32px;
        padding-top: 16px;
        height: 160px;

        .selector {
          text-align: left;
          cursor: pointer;
          color: ${(props) => props.theme.Cool_Gray_Dark_2};
        }
        .selector:hover {
          font-family: "ProximaNova-Bold";
        }
        .ScrollbarsCustom-Track {
          right: -19px !important;
          top: 0px !important;
        }
        .ScrollbarsCustom-ThumbY {
          background-color: ${(props) =>
            handleColorType(props.module, props.theme)} !important;
          width: 6px !important;
        }
        .ScrollbarsCustom-TrackY:before {
          border-left: none;
        }
        .ScrollbarsCustom-TrackY {
          background-color: ${(props) =>
            props.theme.Cool_Gray_Light_2} !important;
          box-shadow: -1px -1px 1.5px ${(props) =>
                props.theme.Cool_Gray_Light_3} inset,
            1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
          width: 6px !important;
        }
      }
    }
  }
  .filter-selected {
    width: 100%;
    height: 40px;
    cursor: pointer;

    .filter-title {
      width: 100%;
      height: 100%;
      display: flex;
      position: relative;
      align-items: flex-end;
      .filter-heading {
        position: absolute;
        top: 0;
        left: 0;
      }
      .title {
        width: 100%;
        text-align: start;

        margin-bottom: 4px;
        &.active {
          color: ${(props) => handleColorType(props.module, props.theme)};
        }
      }
      .filter-icon {
        width: 24px;
        margin-bottom: 2px;
        &.active {
          .cls-3 {
            fill: ${(props) =>
              handleColorType(props.module, props.theme)} !important;
          }
        }
      }
    }
  }
  .filter-selected:hover {
    .filter-reveal {
      height: 120px;
      &.five {
        height: 185px;
      }
      &.long {
        height: 168px;
      }
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    width: 168px;
    height: 56px;

    &.xs {
      width: 50px;
      .filter-title {
        .title {
          padding-left: 5px;
          margin-bottom: 3px !important;
        }
      }
      .filter-icon {
        margin-bottom: 3px !important;
      }
      .filter-selected {
        height: 30px;
      }
      .filter-selected:hover {
        .filter-reveal {
          height: 100px;
          &.five {
            height: 120px;
          }
          &.long {
            height: 130px;
          }
        }
      }
      .filter-reveal {
        width: 50px;
        margin-top: 30px;
        .divider {
          display: none;
        }
        .filter-dd-wrapper {
          height: 100px;

          &.five {
            height: 120px;
          }
          &.long {
            height: 130px;
          }
          .filter-selections {
            padding-right: 0px;
            padding: 0px;
            padding-left: 5px;
          }
        }
      }
    }
    .filter-reveal {
      width: 168px;
      margin-top: 56px;
      .filter-dd-wrapper {
        height: 120px;
        &.five {
          height: 188px;
        }
        &.long {
          height: 168px;
        }
        .selected {
          height: 40px;
        }
        .filter-selections {
          padding: 24px;
          padding-right: 40px;
          padding-top: 16px;
          height: 160px;
          .ScrollbarsCustom-Track {
            right: -18px !important;
            top: 0px !important;
          }

          .ScrollbarsCustom-ThumbY {
            width: 8px !important;
          }
          .ScrollbarsCustom-TrackY {
            width: 8px !important;
          }
        }
      }
    }
    .filter-selected {
      height: 56px;

      .filter-title {
        .title {
          margin-bottom: 10px;
          &.active {
            color: ${(props) => handleColorType(props.module, props.theme)};
          }
        }
        .filter-icon {
          width: 24px;
          margin-bottom: 10px;
        }
      }
    }
    .filter-selected:hover {
      .filter-reveal {
        height: 120px;
        &.five {
          height: 188px;
        }
        &.long {
          height: 168px;
        }
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    width: 200px;
    height: 64px;

    &.xs {
      width: 50px;
      .filter-title {
        .title {
          padding-left: 5px;
          margin-bottom: 3px !important;
        }
      }
      .filter-icon {
        margin-bottom: 3px !important;
      }
      .filter-selected {
        height: 30px;
      }
      .filter-selected:hover {
        .filter-reveal {
          height: 100px;
          &.five {
            height: 120px;
          }
          &.long {
            height: 130px;
          }
        }
      }
      .filter-reveal {
        width: 50px;
        margin-top: 30px;
        .divider {
          display: none;
        }
        .filter-dd-wrapper {
          height: 100px;

          &.five {
            height: 120px;
          }
          &.long {
            height: 130px;
          }
          .filter-selections {
            padding-right: 0px;
            padding: 0px;
            padding-left: 5px;
          }
        }
      }
    }
    .filter-reveal {
      width: 200px;
      margin-top: 64px;
      .filter-dd-wrapper {
        height: 128px;
        &.five {
          height: 205px;
        }
        &.long {
          height: 183px;
        }
        .selected {
          height: 48px;
        }
        .filter-selections {
          padding: 32px;
          padding-right: 48px;
          padding-top: 16px;
          height: 170px;
          .ScrollbarsCustom-Track {
            right: 20px !important;
            top: 0px !important;
          }

          .ScrollbarsCustom-ThumbY {
            width: 10px !important;
          }
          .ScrollbarsCustom-TrackY {
            width: 10px !important;
          }
        }
      }
    }

    .filter-selected {
      height: 64px;

      .filter-title {
        .title {
          margin-bottom: 12px;
          &.active {
            color: ${(props) => handleColorType(props.module, props.theme)};
          }
        }
        .filter-icon {
          width: 32px;
          margin-bottom: 12px;
        }
      }
    }
    .filter-selected:hover {
      .filter-reveal {
        height: 128px;
        &.five {
          height: 205px;
        }
        &.long {
          height: 183px;
        }
      }
    }
  }
`;
function onmouseover() {
  const element = document.getElementById("filter-title");
  const icon = document.getElementById("filter-icon");
  try {
    icon.classList.add("active");
    element.classList.add("active");
  } catch (e) {
    console.log(e);
  }
}

function onmouseout() {
  const element = document.getElementById("filter-title");
  const icon = document.getElementById("filter-icon");
  try {
    icon.classList.remove("active");
    element.classList.remove("active");
  } catch (e) {
    console.log(e);
  }
}

export const Filter = ({
  selected,
  options,
  callback,
  module,
  filterHeading,
  className,
  id,
  index,
}) => {
  const { filterData, setFilterData } = useContext(FilterContext);

  useEffect(() => {
    setFilterData({ selected, filters: options });
  }, [options, selected]);

  let filters = filterData?.filters;

  function onClick(selected) {
    const oldSelected = filterData?.selected;
    let newFilters = filterData?.filters;
    newFilters = newFilters.filter((item) => item !== selected);
    newFilters.push(oldSelected);
    newFilters.sort();

    setFilterData({ selected, filters: newFilters });
    callback(selected);
  }
  if (filters) {
    filters = filters.filter((item) => item !== filterData?.selected);
  }
  let dataLength = filters?.length >= 4 ? "long" : "short";

  if (filters?.length === 5) {
    dataLength = "five";
  }
  if (filters?.length === 0) {
    if (options?.length === 5) {
      dataLength = "five";
    }
    filters = options;
  }

  return (
    <FilterStyle
      id="filter"
      module={module}
      className={`filter-wrapper ${className} ${id}`}
    >
      <div
        className="filter-selected labels21"
        onMouseOver={onmouseover}
        onMouseOut={onmouseout}
        data-cy="filter-dropdown"
      >
        <div className="filter-title">
          {filterHeading && (
            <div className="filter-heading labels21">{filterHeading}</div>
          )}

          <div className="title nav-menu" id={`filter-title-${index}`}>
            {selected}
          </div>
          <div className="filter-icon" id="filter-icon">
            <DownArrowSVG />
          </div>
        </div>
        <div className={`filter-reveal ${dataLength}`}>
          <div className={`filter-dd-wrapper ${dataLength}`}>
            {className !== "xs" && (
              <div className="selected footer15">{filterData?.selected}</div>
            )}
            <div className="filter-selections">
              <Divider />
              <ScrollView>
                <div className="selectors">
                  {filters &&
                    filters.map((filter) => (
                      <div
                        className="selector footer16"
                        onClick={() => onClick(filter)}
                      >
                        {filter}
                      </div>
                    ))}
                </div>
              </ScrollView>
            </div>
          </div>
        </div>
      </div>
    </FilterStyle>
  );
};

Filter.propTypes = {
  module: string,
};

Filter.defaultProps = {
  module: "support",
};
